import { useCurrentRadioSettings } from '@/stores/radio-settings'
import { PiniaPlugin } from 'pinia'

export const piniaRequestLanguageMiddleware: PiniaPlugin = ({ store }) => {
  if (!('events' in store)) return
  if (!(store.events instanceof EventTarget)) return

  store.events.addEventListener('request', (event) => {
    // Ensure this is a Request
    if (!(event instanceof CustomEvent) || !event.detail) return
    const request = event.detail
    if (!(request instanceof Request)) return

    // Don’t set the request language if it has already been set through
    // the Accept-Language header or the URL query parameter.
    const language = request.headers.get('Accept-Language')
    if (language) return
    const url = new URL(request.url)
    if (url.searchParams.has('lang')) return

    const radioSettings = useCurrentRadioSettings()
    if (!radioSettings.value) {
      // some stores can’t have initialized language info yet
      if (['auth', 'users', 'radio-settings'].includes(store.$id)) return
      console.error(
        `Loading state in store '${store.$id}' from '${request.url}'
         but radio settings have not loaded yet. This should not happen.`,
      )
      return
    }

    request.headers.set('Accept-Language', radioSettings.value.i18n.primaryLanguage)
  })
}
